import { stepperStepConfig, STEP } from '@/router/steps';
import type { RouteRecordName } from 'vue-router';
import { type Ref, ref } from 'vue';

interface UseCurrentStep {
  updateCurrentStep: (route: RouteRecordName | null | undefined) => void;
  step: Ref<STEP | undefined>;
}

const currentStep = ref<STEP | undefined>(STEP.INPUT);

export const useCurrentStep = (): UseCurrentStep => {
  const updateCurrentStep = (
    currentRouteName: RouteRecordName | null | undefined,
  ): void => {
    let step: STEP | undefined;
    Object.entries(stepperStepConfig).forEach(([key, config]) => {
      if (currentRouteName === null || currentRouteName === undefined) {
        return;
      }

      const path: string | undefined = currentRouteName
        .toString()
        .split('.')[1];
      if (path !== undefined && path.includes(config.routeName)) {
        step = key as STEP;
      }
    });

    currentStep.value = step;
  };

  return {
    updateCurrentStep,
    step: currentStep,
  };
};
